<template>
  <DocLayout :doc="doc" :show-text-controls="false">
    <template #page-content>
      <section class="book-highlights">
        <div class="container book-highlights__container">
          <!--div class="return-box return-box--highlights">
            <a class="return-box__link" href="book-reading.html"
              ><span class="return-box__icon iconfont iprev"></span>Back to
              Highlights</a
            >
          </div-->

          <Hero :doc="doc" title="Highlights, notes and bookmarks of" />

          <!--div class="book-highlights__filter">
              <form class="filter-box__form">
                  <div class="keywords keywords--half">
                      <input class="keywords__input" type="text" name="search" placeholder="Search highlights or notes..."/>
                      <a class="keywords__btn" href="javascript:void(0);"><span class="iconfont isearch"></span></a>
                  </div>
                  <div class="sort-by sort-by--half select-box">
                      <span class="sort-by__name">Sort by: </span>
                      <input class="sort-by__input select" type="text" name="sort-by"/>
                      <ul class="sort-by__option option">
                          <li><a class="sort-by__link" href="javascript:void(0);"><span class="sort-by__icon"><img src="@/assets.app/images/sort-by-01.svg" alt=""/></span><span class="select-c">Latest</span></a></li>
                          <li><a class="sort-by__link" href="javascript:void(0);"><span class="sort-by__icon"><img src="@/assets.app/images/sort-by-02.svg" alt=""/></span><span class="select-c">Popular</span></a></li>
                          <li><a class="sort-by__link" href="javascript:void(0);"><span class="sort-by__icon"><img src="@/assets.app/images/sort-by-03.svg" alt=""/></span><span class="select-c">Alphabetical</span></a></li>
                      </ul>
                  </div>
              </form>
          </div-->

          <HighlightsList :doc="doc" />
        </div>
      </section>
    </template>
  </DocLayout>
</template>

<script setup lang="ts">
import DocLayout from '@/app/components/doc/Layout.vue'
import Hero from '@/app/components/doc/highlights/Hero.vue'
import HighlightsList from '@/app/components/doc/highlights/HighlightsList.vue'

import type { DocView } from '@/models/doc'

defineProps<{
  doc: DocView
}>()
</script>
